import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Nav from "./Nav";
import Footer from "./Footer";

export default function Layout() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);

    return (
        <div
            className="min-h-screen relative paper"
            data-testid="app-layout-root"
        >
            <div className="grain" aria-hidden="true" />
            <Nav />
            <main className="relative z-10">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
